import { render, staticRenderFns } from "./AddPresentationModalV2.vue?vue&type=template&id=03cf5aad&scoped=true"
import script from "./AddPresentationModalV2.vue?vue&type=script&lang=js"
export * from "./AddPresentationModalV2.vue?vue&type=script&lang=js"
import style0 from "./AddPresentationModalV2.vue?vue&type=style&index=0&id=03cf5aad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cf5aad",
  null
  
)

export default component.exports